<template>
  <div class="audio">
    <audio id="myAudio" controls autoplay>
      <source src="../assets/music.ogg" type="audio/ogg" />
      <source src="../assets/music.mp3" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.audio {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 50px;
  z-index: 4;
}
</style>